import { render } from "./InactivityWarning.vue?vue&type=template&id=2916c849&scoped=true"
import script from "./InactivityWarning.vue?vue&type=script&lang=js"
export * from "./InactivityWarning.vue?vue&type=script&lang=js"

import "./InactivityWarning.vue?vue&type=style&index=0&id=2916c849&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2916c849"]])

export default __exports__